/**
 * Formatacao de data para exibicao, em pt-BR.
 *
 * O servidor envia data pura (`2027-03-31`) para prazo e data com hora em UTC
 * para carimbos de criacao e atualizacao. Os dois casos precisam de tratamento
 * diferente, e confundi-los desloca o prazo em um dia: `new Date('2027-03-31')`
 * e interpretado como meia-noite UTC, que em UTC-3 cai no dia 30.
 */

const formatadorDeData = new Intl.DateTimeFormat('pt-BR', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
});

const formatadorDeDataHora = new Intl.DateTimeFormat('pt-BR', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});

/**
 * Formata uma data pura, do tipo `2027-03-31`.
 *
 * Monta a data pelos componentes, no fuso local, justamente para nao passar pela
 * interpretacao como UTC.
 */
export function formatarData(iso: string | null | undefined): string {
  /*
    ACEITA `undefined` DE PROPOSITO, apesar de o contrato declarar `string | null`.

    Isto e uma funcao de fronteira: o que chega aqui veio de JSON, e JSON nao e
    verificado pelo compilador. O servidor ja omitiu campo nulo uma vez, e o resultado
    foi a tela inteira em branco com "Cannot read properties of undefined" porque uma
    acao sem prazo chegou sem o campo. Trocar a pagina toda por um travessao numa celula
    e a troca certa.
  */
  if (iso === null || iso === undefined || iso === '') {
    return '—';
  }

  const partes = iso.slice(0, 10).split('-');

  if (partes.length !== 3) {
    return '—';
  }

  const [ano, mes, dia] = partes.map(Number);

  if (ano === undefined || mes === undefined || dia === undefined) {
    return '—';
  }

  return formatadorDeData.format(new Date(ano, mes - 1, dia));
}

/** Formata um instante em UTC, convertendo para o fuso do navegador. */
export function formatarDataHora(iso: string | null | undefined): string {
  // Mesma razao de `formatarData`.
  if (iso === null || iso === undefined || iso === '') {
    return '—';
  }

  // O servidor serializa DateTime de UTC sem sufixo de fuso. Sem o 'Z' o
  // navegador interpretaria como hora local e mostraria o carimbo com tres horas
  // de diferenca.
  const normalizado = /[Zz]|[+-]\d{2}:\d{2}$/.test(iso) ? iso : `${iso}Z`;
  const instante = new Date(normalizado);

  return Number.isNaN(instante.getTime()) ? '—' : formatadorDeDataHora.format(instante);
}
